<template>
    <div class="wrapper" v-if="isActive" :class="isShow && `show`">
        <div class="backdrop" @click="close"></div>
        <button type="button" class="SearchClose" @click="close">
            <span class="material-symbols-outlined">close</span>
        </button>

        <div class="SearchContent">

            <div class="SearchBoxWrap">
                <div class="SearchContainer">
                    <form @submit.prevent="submitForm" class="searchbox">
                        <input ref="input" id="searchbox" v-model.trim="query" class="searchboxInput" type="text"
                            autocomplete="off" />

                        <label for="searchbox" class="searchboxLabel">
                            <span class="material-symbols-outlined">search</span>
                        </label>

                        <div class="searchboxAction">
                            <button v-if="query != ''" type="button" class="searchboxClear" @click="clearInput">
                                <span class="material-symbols-outlined">close</span>
                            </button>
                        </div>
                    </form>
                </div>

            </div>
            <div class="SearchResults">

                <div v-if="isLoad"></div>
                <div class="SearchContainer" v-else>
                    <div class="cetagoryWrap" v-if="cetagoryList.length && query != ''">

                        <section class="cetagory-section" v-for="(cetagory, index) in cetagoryList" :key="index">
                            <h2 class="cetagory-title">{{ cetagory.title }}</h2>

                            <div class="cetagory-card-list">
                                <div class="cetagory-card" v-for="(item, index) in cetagory.items" :key="index">
                                    <a :href="item.uri" class="cardContent">
                                        <div class="cardThumb">
                                            <div class="thumb">
                                                <img v-if="item.imageUrl" :src="item.imageUrl" :alt="item.title">
                                            </div>
                                        </div>
                                        <div class="cardBody">
                                            <h3 class="cardTitle">{{ item.title }}</h3>
                                            <div class="cardDescription">{{ item.description }}</div>
                                        </div>
                                    </a>
                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            isActive: false,
            isShow: false,
            query: ``,

            cetagoryList: [],
            isLoad: false,
        }
    },

    computed: {
        hasSearch() {
            return this.$store.getters.hasSearch
        },
    },

    created() {
        this.debounced = _.debounce(this.setQuestion, 500);

        if (typeof window !== "undefined") {
            this.scrollHandler();
            window.addEventListener("scroll", this.scrollHandler);
        }
    },

    watch: {
        hasSearch(val) {
            if (val) {
                this.isActive = true
                this.focusInputHandle()
            }
            else {
                this.closeHandle()
            }
        },
        isActive(val) {
            if (val) {
                document.body.classList.add('has-search');
            }
            else {
                document.body.classList.remove('has-search');
            }
        },
        query() {
            this.debounced()
        }
    },

    mounted() {
        this.onInit()
    },
    methods: {
        onInit() {
        },
        setQuestion() {
            if (this.query != '') {
                this.cetagoryList = []
                this.find();
            }
        },

        resizeHandler() {
        },
        scrollHandler() {
        },

        submitForm() {

        },

        clearInput() {
            this.query = ''

            if (this.$refs.input) {
                this.$refs.input.focus()
            }
        },

        close() {
            this.$store.dispatch('hasSearch', false)
        },

        async find() {
            if (this.isLoad) return false

            this.isLoad = true
            this.cetagoryList = []

            try {
                const { data: response } = await axios.get('/api/search', {
                    params: {
                        q: this.query
                    }
                })

                if (response.data) {
                    this.cetagoryList = response.data
                }


            } catch (error) {
                console.log(error);
            }


            this.isLoad = false
        },

        focusInputHandle() {
            setTimeout(() => {
                this.isShow = true

                if (this.$refs.input) {
                    this.$refs.input.focus()
                }

            }, 100);
        },

        closeHandle() {
            this.isShow = false

            setTimeout(() => {
                this.isActive = false
                this.query = ``
                this.cetagoryList = []
            }, 100);
        }
    },

}
</script>


<style lang="scss" scoped>
.wrapper {
    position: fixed;
    inset: 0px;

    will-change: background-color;
    width: 100vw;
    height: 100vh;

    z-index: 1001;

    &.show {

        .SearchContent {
            opacity: 1;
            transform: translateY(0px);
        }

        .backdrop {
            opacity: 1;
            visibility: visible;
            background-color: rgba(0, 0, 0, 0.5);
        }

        .SearchClose{
            opacity: 1;
        }
    }
}

.backdrop {
    position: fixed;
    inset: 0px;
    will-change: background-color;
    width: 100vw;
    height: 100vh;
    cursor: pointer;
    visibility: hidden;

    transition: background-color 100ms cubic-bezier(0.15, 0.15, 0, 1) 0s, visibility 0ms linear 0s;
    background-color: transparent;
    opacity: 0;
}

.SearchClose {
    position: fixed;
    z-index: 200;

    top: 8px;
    // left: 8px;
    right: 8px;

    height: 44px;
    width: 44px;

    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    border-width: 0;

    background-color: rgba(0, 0, 0, 0.1);
    opacity: 0;
    transition: opacity 100ms cubic-bezier(0.15, 0.15, 0, 1) 0s
}

.SearchContent {
    display: flex;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;

    width: 100%;
    flex-direction: column;
    will-change: opacity, transform;

    overflow: hidden;
    z-index: 1;
    height: 100%;

    opacity: 0;
    transform: translateY(-100%);
    transition: opacity 100ms cubic-bezier(0.15, 0.15, 0, 1) 0s, transform 100ms cubic-bezier(0.15, 0.15, 0, 1) 0s;


}

.SearchContainer {
    width: 100%;
    max-width: 890px;
    margin-left: auto;
    margin-right: auto;

    padding-left: 15px;
    padding-right: 15px;

    height: 100%;
    display: flex;
    flex-direction: column;
}

.SearchBoxWrap {
    padding-top: 8px;
    padding-bottom: 8px;
    // padding-left: 60px;
    // padding-right: 8px;

    background-color: rgb(255, 254, 253);
}

.SearchResults {
    background-color: #fff;
    overflow: hidden auto;
    
}

.searchbox {
    display: flex;
    position: relative;
    align-items: center;
    height: 44px;
    background-color: rgb(243, 242, 241);

    margin-right: 48px;
}

.searchboxLabel {
    position: absolute;
    height: 44px;
    width: 44px;
    left: 0;
    top: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
}

.searchboxInput {
    flex: 1;
    font-size: 24px;
    font-weight: 400;
    font-family: var(--font-family, "Srinakharinwirot", sans-serif);
    // background-color: rgb(243, 242, 241);
    padding: 4px 15px 4px 42px;
    width: 100%;
    outline: none;
    height: 44px;
    line-height: 1.2;
    background-color: transparent;

    outline: none;
    border-width: 0;
}

.searchboxClear {
    height: 28px;
    width: 28px;

    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    border-width: 0;
    background-color: transparent;
}

.searchboxSubmit {
    height: 44px;
    background-color: var(--color-primary);
    color: #fff;
    padding: 4px 12px;

    border-width: 0;
}

.searchboxAction {
    display: flex;
    gap: 10px;
    align-items: center;
    // right: 10px;
    padding-right: 10px;

    // right: 0;
    // top: 0;
    // position: absolute;
}

.cetagory-card-list {
    display: flex;
    flex-wrap: wrap;
    margin-right: -7.5px;
    margin-left: -7.5px;

}

.cetagory-card {
    flex: 0 0 100%;
    max-width: 100%;

    position: relative;
    width: 100%;
    padding-right: 7.5px;
    padding-left: 7.5px;
    margin-bottom: 15px;
}

.cardContent {
    display: flex;
    gap: 10px;
    flex-direction: column;
    background-color: #fff;
}

a.cardContent {
    text-decoration: none;
}

.cardTitle {
    color: #101010;
    font-size: 18px;
    margin-bottom: 0;
    font-weight: bold;

    line-height: 1.2;

    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    max-height: calc(2 * 28px * 1.2);
}

.cardDescription {
    font-size: 15px;

    line-height: 1.2;

    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    max-height: calc(3 * 28px * 1.2);
    color: #666;
}

.cardThumb {
    .thumb {
        position: relative;
        display: block;
        overflow: hidden;
        height: 0;
        padding-top: 56.25%;
        background: rgb(238 238 238 / 93%);

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            inset: 0;
        }
    }
}

.cardBody {
    display: flex;
    gap: 3px;
    flex-direction: column;
}

.cetagory-title {
    font-weight: bold;
    font-size: 28px;

}

.cetagoryWrap {
    display: flex;
    flex-direction: column;

    gap: 30px;
}

@media (min-width: 410px) {
    .cetagory-card {
        flex: 0 0 50%;
        max-width: 50%;
    }
}


@media (min-width: 600px) {
    .cetagory-card {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
}

@media (min-width: 768px) {

    .searchboxSubmit {
        min-width: 120px;
    }

    .SearchBoxWrap {
        padding-top: 20px;
    }

    .SearchClose {
        left: auto;
        top: 20px;
        right: 15px;
    }

    .SearchResults{
        padding-bottom: 15px;
    }
}

@media (min-width: 1024px) {
    .searchbox{
        margin-right: 0;
    }
    
}

@media (min-width: 801px) and (orientation: landscape),
(min-width: 1025px) {}
</style>